module.exports = __webpack_public_path__ + "img/momo_agents-min.7dbbea13.jpg";